import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { BiEraser, BiPlus } from "react-icons/bi";
import styled from "styled-components";
import { undoableDeleteModule } from "../../stores/undo/operation/ModuleDeletionOp";
import { undoableDeleteWorkshop } from "../../stores/undo/operation/WorkshopDeletionOp";
import { managementStore } from "../../stores/ManagementStore";
import { ListItem } from "../menu/ListItem";
import { MenuCard } from "../menu/MenuCard";
import { Input } from "../shared/Input";
import { ModuleDetailView } from "./ModuleDetailView";
import { WorkshopDetailView } from "./WorkshopDetailView";
import Modal from "react-modal";
import { CustomModalStyles, ModalDeleteCloseButtonBar, ModalTitle } from "../modal/ModalComponents";
import { useTranslation } from "react-i18next";
import { AiFillStar } from "react-icons/ai";
import { undoableCreateWorkshop } from "../../stores/undo/operation/WorkshopCreationOp";
import { undoableCreateModule } from "../../stores/undo/operation/ModuleCreationOp";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { undoableManagementToggleItemViewOpen } from "../../stores/undo/operation/ManagementToggleItemViewOpenOp";
const ToolBar = styled.div.withConfig({
  displayName: "ManagementListView__ToolBar",
  componentId: "sc-i1xo9t-0"
})(["min-height:30px;display:flex;flex-wrap:wrap;gap:10px;"]);
const NewButton = styled.button.withConfig({
  displayName: "ManagementListView__NewButton",
  componentId: "sc-i1xo9t-1"
})(["flex-shrink:0;height:26px;"]);
const DeleteButton = styled.button.withConfig({
  displayName: "ManagementListView__DeleteButton",
  componentId: "sc-i1xo9t-2"
})(["flex-shrink:0;height:26px;"]);
const ListFilterContainer = styled.span.withConfig({
  displayName: "ManagementListView__ListFilterContainer",
  componentId: "sc-i1xo9t-3"
})(["margin-left:auto;"]);
const ListView = styled(MenuCard).withConfig({
  displayName: "ManagementListView__ListView",
  componentId: "sc-i1xo9t-4"
})(["overflow-y:scroll;"]);
const ContentListItem = styled(ListItem).withConfig({
  displayName: "ManagementListView__ContentListItem",
  componentId: "sc-i1xo9t-5"
})([":hover{cursor:default;}"]);
const ListItemHeader = styled.div.withConfig({
  displayName: "ManagementListView__ListItemHeader",
  componentId: "sc-i1xo9t-6"
})(["display:contents;:hover{cursor:pointer;}"]);
const ListItemBody = styled.div.withConfig({
  displayName: "ManagementListView__ListItemBody",
  componentId: "sc-i1xo9t-7"
})(["color:black;"]);
const ManagementListView = observer(props => {
  const {
    t
  } = useTranslation();
  const [selectedItems, setSelectedItems] = useState(Array());
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [filterText, setFilterText] = useState("");

  const isItemSelected = id => {
    return selectedItems.includes(id);
  };

  const toggleItemSelection = id => {
    if (isItemSelected(id)) {
      setSelectedItems(selectedItems.filter(item => item !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const itemName = item => {
    const name = props.getItemName(item);
    return name ? name : `(${t(props.newItemPlaceholderTranslationString)})`;
  };

  const deleteSelectedItems = () => {
    selectedItems.map(id => props.workshopStoreDeleter(id));
    setSelectedItems([]);
  };

  function openModal(e) {
    e.stopPropagation();
    setModalIsOpen(true);
  }

  function closeModal(e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setModalIsOpen(false);
  }

  function confirm() {
    closeModal();
    deleteSelectedItems();
  }

  const filteredItems = () => {
    // case-insensitive search
    return props.workshopStoreGetter().slice().reverse().filter(item => {
      const itemName = props.getItemName(item).toLowerCase();
      const searchText = filterText.toLowerCase();
      return itemName.includes(searchText);
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToolBar, null, /*#__PURE__*/React.createElement(NewButton, {
    onClick: () => props.createNewItem()
  }, /*#__PURE__*/React.createElement(BiPlus, null), " ", t(props.newItemPlaceholderTranslationString)), /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: e => openModal(e),
    disabled: selectedItems.length == 0
  }, /*#__PURE__*/React.createElement(BiEraser, null), " ", t("management.delete_selected")), /*#__PURE__*/React.createElement(ListFilterContainer, null, t("management.filter"), ": ", /*#__PURE__*/React.createElement(Input, {
    value: filterText,
    onChange: ({
      target
    }) => setFilterText(target.value)
  }))), /*#__PURE__*/React.createElement(ListView, null, filteredItems().map(item => {
    return /*#__PURE__*/React.createElement(ContentListItem, {
      key: props.getItemId(item),
      className: isItemSelected(props.getItemId(item)) ? "selected" : ""
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: isItemSelected(props.getItemId(item)),
      onChange: () => toggleItemSelection(props.getItemId(item))
    }), /*#__PURE__*/React.createElement(ListItemHeader, {
      onClick: () => undoableManagementToggleItemViewOpen(props.getItemId(item))
    }, managementStore.isDetailViewOpen(props.getItemId(item)) ? /*#__PURE__*/React.createElement(IoMdArrowDropdown, null) : /*#__PURE__*/React.createElement(IoMdArrowDropright, null), props.isItemHighlited(item) ? /*#__PURE__*/React.createElement("span", null, " ", /*#__PURE__*/React.createElement(AiFillStar, null)) : '', itemName(item)), /*#__PURE__*/React.createElement(ListItemBody, null, managementStore.isDetailViewOpen(props.getItemId(item)) && props.detailView(props.getItemId(item))));
  }))), /*#__PURE__*/React.createElement(Modal, {
    isOpen: modalIsOpen,
    onRequestClose: closeModal,
    shouldCloseOnOverlayClick: true,
    style: CustomModalStyles,
    shouldCloseOnEsc: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, t("management.delete_selected_items_title")), t("management.items_to_delete"), " ", selectedItems.map((item, index) => /*#__PURE__*/React.createElement("b", {
    key: item
  }, itemName(props.getItem(item)), index != selectedItems.length - 1 ? ', ' : '')), /*#__PURE__*/React.createElement(ModalDeleteCloseButtonBar, {
    confirm: confirm,
    closeModal: closeModal
  })));
});
export const WorkshopListView = observer(() => {
  return /*#__PURE__*/React.createElement(ManagementListView, {
    workshopStoreGetter: () => managementStore.getAllWorkshops,
    workshopStoreDeleter: id => undoableDeleteWorkshop(managementStore.getWorkshop(id)),
    getItem: id => managementStore.getWorkshop(id),
    getItemId: workshop => workshop.$modelId,
    getItemName: workshop => workshop.name,
    isItemHighlited: _ => false,
    detailView: id => /*#__PURE__*/React.createElement(WorkshopDetailView, {
      editItem: id
    }),
    createNewItem: () => {
      undoableCreateWorkshop();
    },
    newItemPlaceholderTranslationString: "management.new_workshop"
  });
});
export const ModulesOfWorkshopListView = observer(props => {
  return /*#__PURE__*/React.createElement(ManagementListView, {
    workshopStoreGetter: () => managementStore.getModulesForWorkshop(props.workshopId),
    workshopStoreDeleter: moduleId => undoableDeleteModule(managementStore.getModule(moduleId)),
    getItem: moduleId => managementStore.getModule(moduleId),
    getItemId: module => module ? module.$modelId : "",
    getItemName: module => module ? module.name : "[ERROR: Module not found]",
    isItemHighlited: module => module ? module.highlighted : false,
    detailView: editItem => /*#__PURE__*/React.createElement(ModuleDetailView, {
      editItem: editItem
    }),
    createNewItem: () => {
      undoableCreateModule(props.workshopId);
    },
    newItemPlaceholderTranslationString: "management.new_module"
  });
});